import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";
import task03 from "./layouts/task-03/task";

const lesson: Lesson = {
  id: "7c525bba-3a53-4df6-aa09-a3dc6a736547",
  publicId: "2",
  name: "Basics of Electricity",
  difficulty: 1,
  contentTypes: { audio: true, interactive: true, video: false },
  body: [principle01, task01, task02, task03],
};

export default lesson;
